import { Accordion } from '../../molecules/accordion/Accordion';
import { iconsAccordion } from './options';
import { Text } from '../../typography/text/Text';
import styles from './ProductInfo.module.scss';
import React from 'react';
import { convertTextToId } from '../../../utils/convertTextToId';
import { ReactNode } from 'react';

export interface ProductInfoData {
  id: string;
  title: string;
  markup: string | ReactNode;
  icon: React.FC;
}

export interface ProductInfoProps {
  data: ProductInfoData[];
  className?: string;
}
const ProductInfo: React.FC<ProductInfoProps> = ({ data, className }) => {
  const wrapInUl = (str) => {
    let htmlString = str;
    const ulRegex = /<ul\b[^>]*>[\s\S]*<\/ul>/i;
    const olRegex = /<ol\b[^>]*>[\s\S]*<\/ol>/i;

    if (ulRegex.test(htmlString) || olRegex.test(htmlString)) {
      return htmlString;
    }

    const firstLiIndex = htmlString.indexOf('<li>');
    const lastLiIndex = htmlString.lastIndexOf('</li>');

    if (firstLiIndex !== -1 && lastLiIndex !== -1) {
      htmlString = htmlString.slice(0, firstLiIndex) + '<ul>' + htmlString.slice(firstLiIndex);
      const endIndex = lastLiIndex + '</li>'.length + 4;
      htmlString = htmlString.slice(0, endIndex) + '</ul>' + htmlString.slice(endIndex);
    }

    return htmlString;
  };

  return (
    <Accordion
      className={`${styles.accordionWrapperPDP} ${className}`}
      customClasses={{ accordionWrapper: styles.accordionWrapper }}
      canOpenMultiple={false}
    >
      {data.map(({ id, title, markup, icon: Icon }, i) => {
        return (
          <Accordion.Section
            id={id}
            title={title}
            key={id}
            customClasses={{ section: styles.section }}
            isOpen={i === 0}
          >
            <Accordion.Title
              iconToOpen={iconsAccordion.iconToOpen}
              iconToClose={iconsAccordion.iconToClose}
              data-product-info={convertTextToId(title)}
              customClasses={{
                title: title === 'PAYMENT OPTIONS' ? styles.specificTitle : styles.title,
                content: styles.content,
              }}
              isRotate={false}
              timeout={200}
            >
              <Icon />
              <Text
                className={`${styles.accordionLabel} ${title === 'PAYMENT OPTIONS' && styles.spicificLabel}`}
                weight="normal"
                as="p"
                textTransform="uppercase"
              >
                {title.toString()}
              </Text>
            </Accordion.Title>
            {/*@ts-ignore*/}
            <Accordion.Panel>
              {typeof markup === 'string' ? (
                <div
                  className={styles.dynamicContentBlock}
                  dangerouslySetInnerHTML={{
                    __html: wrapInUl(markup),
                  }}
                />
              ) : (
                <div className={styles.dynamicContentBlock}>{markup}</div>
              )}
            </Accordion.Panel>
          </Accordion.Section>
        );
      })}
    </Accordion>
  );
};

export default ProductInfo;
